export const LIGHT_MODE = 'light';
export const DARK_MODE = 'dark';